import { createAction } from '@reduxjs/toolkit';
import karmaEarnListSlice from './slice';

export const fetchKarmaEarnList = createAction('karmaEarnList/fetchKarmaEarnList');

export const {
  reset,
  receiveItems,
  addItems,
  resetItems,
  setIsMyOffers,
  setGenres,
  setDeviceTypes,
  setIsLoading,
  setIsVpnDetected,
  setOfferType,
} = karmaEarnListSlice.actions;
